export const AI_NAME = 'Sttok AI';
